import { Briefcase, Euro, ListTodo, StickyNote, UserPlus } from "lucide-react";
import { useTranslate } from "ra-core";
import { useState } from "react";
import { useNavigate } from "react-router";

import { ContactCreateSheet } from "../../contacts/ContactCreateSheet";
import { NoteCreateSheet } from "../../notes/NoteCreateSheet";
import { TaskCreateSheet } from "../../tasks/TaskCreateSheet";

type Sheet = "task" | "note" | "contact" | null;

/** Tarea · Nota · Oportunidad · Factura · Contacto, with the app's real create flows. */
export const QuickActions = () => {
  const translate = useTranslate();
  const navigate = useNavigate();
  const [sheet, setSheet] = useState<Sheet>(null);
  const sheetProps = (name: Exclude<Sheet, null>) => ({
    open: sheet === name,
    onOpenChange: (open: boolean) => setSheet(open ? name : null),
  });
  const actions = [
    { key: "task", icon: ListTodo, run: () => setSheet("task") },
    { key: "note", icon: StickyNote, run: () => setSheet("note") },
    { key: "deal", icon: Briefcase, run: () => navigate("/deals/create") },
    { key: "invoice", icon: Euro, run: () => navigate("/invoices/create") },
    { key: "contact", icon: UserPlus, run: () => setSheet("contact") },
  ];

  return (
    <nav className="home-quick" aria-label={translate("desk.home.quick.title")}>
      {actions.map(({ key, icon: Icon, run }) => (
        <button
          key={key}
          type="button"
          className="home-quick__tile desk-press"
          onClick={run}
          title={translate(`desk.home.quick.${key}_hint`)}
        >
          <Icon aria-hidden className="size-[18px]" strokeWidth={1.6} />
          <span>{translate(`desk.home.quick.${key}`)}</span>
        </button>
      ))}
      <TaskCreateSheet {...sheetProps("task")} />
      <NoteCreateSheet {...sheetProps("note")} />
      <ContactCreateSheet {...sheetProps("contact")} />
    </nav>
  );
};
